// extracted by mini-css-extract-plugin
export default {"card":"a7-z"};